import { createContext, useContext, useLayoutEffect } from "react";

export const HeaderThemeContext = createContext({ dark: false, setDark: () => {} });

/** Call from any component that renders a dark full-bleed hero at the top of the page. */
export const useDarkHero = () => {
  const { setDark } = useContext(HeaderThemeContext);
  useLayoutEffect(() => {
    setDark(true);
    return () => setDark(false);
  }, [setDark]);
};
